module.exports = __webpack_public_path__ + "img/B.80884399.png";